  document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".faqAccordion details");

    items.forEach((item) => {
      item.addEventListener("toggle", () => {
        if (item.open) {
          items.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.removeAttribute("open");
            }
          });
        }
      });
    });
  });